export default {
  noData: 'No data to display.',
  termsAndConditions: 'Terms and Conditions',
  privacy: 'Privacy Policy',
  upload: 'Upload',
}
